import {createSlice} from '@reduxjs/toolkit'

const initialState = {
    isOpen: false,
    setToVar: null,
    initialFile: {},
    params: {}
}
export const uploadAvatarSlice = createSlice({
    name: 'uploadAvatar',
    initialState: initialState,
    reducers: {
        onOpenAvatarUpload: (state, action) => {
            state.isOpen = true
            state.setToVar = action.payload.setToVar
            state.initialFile = action.payload.file
        },
        onCloseAvatarUpload: (state, action) => {
            state.isOpen = false
            setTimeout(() => {
                state = {
                    ...initialState
                }
            })
        }
    }
})

export const {
    onOpenAvatarUpload,
    onCloseAvatarUpload,

} = uploadAvatarSlice.actions;

export default uploadAvatarSlice.reducer;